module.exports = __webpack_public_path__ + "img/1.5730ab99.png";